import { GraphQLClient } from "graphql-request";

const API_URL = `${process.env.NEXT_PUBLIC_API_URL}/customer/graphql`;

export const graphqlClient = new GraphQLClient(API_URL, {
  credentials: "include",
  fetch: (input, init) => {
    // Extract the operation name from the request body if available
    const body = init?.body ? JSON.parse(init.body as string) : {};
    const operationName = body.operationName || "unnamed";

    // Create a new URL with the operation name as a query parameter
    const urlWithOperationName = `${input}?op=${operationName}`;

    // Return the fetch call with the modified URL
    return fetch(urlWithOperationName, {
      ...init,
      body: JSON.stringify(body), // Ensure the body is still sent
    });
  },
});
